import { render, staticRenderFns } from "./UserRow.vue?vue&type=template&id=b45a7eda&scoped=true&"
import script from "./UserRow.vue?vue&type=script&lang=js&"
export * from "./UserRow.vue?vue&type=script&lang=js&"
import style0 from "./UserRow.vue?vue&type=style&index=0&id=b45a7eda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b45a7eda",
  null
  
)

export default component.exports